import { QuizAnswer, RoastType, RoastWeights } from './types';

export function calculateRoastType(answers: QuizAnswer[]): RoastType {
  const totals: RoastWeights = {
    light: 0,
    medium: 0,
    dark: 0,
    espresso: 0
  };

  // Sum up all the weights from answers
  answers.forEach(answer => {
    Object.entries(answer.weights).forEach(([roastType, weight]) => {
      totals[roastType as RoastType] += weight || 0;
    });
  });

  // Find the roast type with the highest score
  let maxScore = 0;
  let resultType: RoastType = 'medium'; // Default fallback

  Object.entries(totals).forEach(([roastType, score]) => {
    if (score > maxScore) {
      maxScore = score;
      resultType = roastType as RoastType;
    }
  });

  return resultType;
}